import { startCase } from 'lodash';
import Image from 'next/image';

interface RENDER_BROKER_LIST_PROPS {
  name: string;
  type: string;
  logoUrl: string;
  onClickHandler: () => void;
}

export const RenderBrokerList = ({
  name,
  type,
  logoUrl,
  onClickHandler,
}: RENDER_BROKER_LIST_PROPS): JSX.Element => {
  return (
    <div
      className="border-sm border-[#EBEBEC] rounded-md px-4 mb-8 relative cursor-pointer hover:border-[#8EBEFD] hover:text-[#8EBEFD] hover:bg-[#EEF5FF] sm:px-2"
      onClick={onClickHandler}
    >
      <div className="text-center mt-6 mb-1 w-full sm:w-8 sm:h-8 mx-auto sm:mb-3">
        <Image
          src={
            logoUrl ||
            'https://assets1.cleartax-cdn.com/finfo/wg-utils/retool/d9f36ac3-77a9-40c6-94fc-20c2e3855457.svg'
          }
          alt={name}
          width={40}
          height={40}
          priority
        />
      </div>

      <div className="font-medium mb-6 w-full text-center text-grey-700 text-s-12">
        {name}
      </div>
      <div className="text-s-10 text-center bg-[#F4F4F5] rounded-br-sm rounded-bl-sm  absolute px-2 py-[2px] bottom-[-20px] left-0 right-0 mx-3 hover:bg-[#EEF5FF]">
        {startCase(type.toLowerCase())}
      </div>
    </div>
  );
};
